var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.265235 9.64034L7.59868 16.9738C7.95236 17.3274 8.52578 17.3274 8.87942 16.9738L9.73475 16.1184C10.0878 15.7653 10.0885 15.1931 9.73626 14.8392L3.92437 8.99995L9.73626 3.16075C10.0885 2.80684 10.0878 2.2346 9.73475 1.88152L8.87942 1.0262C8.52574 0.67251 7.95233 0.67251 7.59868 1.0262L0.265235 8.35956C-0.0884113 8.71325 -0.0884113 9.28666 0.265235 9.64034Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.fbf750c532f8acb5c701f6d22350d59d.svg";
export { ForwardRef as ReactComponent };